import React from 'react';
import PropTypes from 'prop-types';

import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Tooltip } from '@mui/material';

import { reverseFormatDate } from '../../../utils/dateFunctions';

const SchedulingAssistantEventContent = ({ eventInfo, onNav, eventHeight }) => {
    const {
        participant,
        location,
        additionalDetails,
        appointmentType,
        content,
        timeContent,
        eventType,
        slots,
        filledSlots,
        hasLink,
        displayStart,
        displayEnd,
        hasOverlap,
        repeat,
        repeatUntilDate,
        displayOccurrence
    } = eventInfo.event.extendedProps;

    const renderOccurrenceContent = () => (
        <div>
            {repeat} until {reverseFormatDate(repeatUntilDate)}
        </div>
    );

    const renderContent = (eventInfo, displayRestartIcon = false) => {
        const copy = (
            <>
                {eventInfo.timeText && eventType !== 'hidden' && (
                    <div className="fc-event-time" data-testid="time-content">
                        {timeContent}
                    </div>
                )}
                <div className="fc-event-title-container">
                    <div className="fc-event-title">
                        <div data-testid="display-time-content">
                            {displayStart} - {displayEnd}
                        </div>
                        {eventType !== 'participant' && (
                            <span className="content-text">{content}</span>
                        )}
                        {appointmentType && <span>{appointmentType}</span>}
                        {slots && <span> - {filledSlots} </span>}
                        {participant && !hasLink && <span> - {participant}</span>}
                        {participant && hasLink && (
                            <>
                                <span> - </span>
                                <span
                                    className="event-link"
                                    onClick={() => onNav(eventInfo.event.extendedProps)}>
                                    {participant}
                                </span>
                            </>
                        )}
                        {eventType === 'participant' && location && (
                            <span data-testid="event-location"> - {location} </span>
                        )}
                        {additionalDetails && (
                            <span data-testid="event-additional-details">
                                - {additionalDetails}
                            </span>
                        )}
                    </div>
                </div>
            </>
        );
        const eventContent = (
            <div
                className="fc-event-main-frame"
                style={{
                    minHeight: hasOverlap ? `${eventHeight / 2}px` : `${eventHeight}px`,
                    height: hasOverlap ? `${eventHeight / 2}px` : `${eventHeight}px`,
                    maxHeight: hasOverlap ? `${eventHeight / 2}px` : `${eventHeight}px`
                }}
                data-testid="scheduling_assistant_event_content">
                <>
                    {displayRestartIcon && (
                        <div className="occurrence-content">
                            <Tooltip
                                title={renderOccurrenceContent()}
                                placement="bottom"
                                leaveDelay={200}>
                                <RestartAltIcon />
                            </Tooltip>
                        </div>
                    )}
                    {copy}
                </>
            </div>
        );
        const toolTipContent = <div className="fc-event-main-frame">{copy}</div>;
        return [eventContent, toolTipContent];
    };

    const renderEventContent = () => {
        const [eventContent, toolTipContent] = renderContent(eventInfo, displayOccurrence);
        return (
            <Tooltip title={toolTipContent} placement="top" leaveDelay={200}>
                {eventContent}
            </Tooltip>
        );
    };

    return <>{renderEventContent()}</>;
};

SchedulingAssistantEventContent.propTypes = {
    eventInfo: PropTypes.object,
    onNav: PropTypes.func,
    eventHeight: PropTypes.number
};

export default SchedulingAssistantEventContent;
